import {useLocale} from '@/localization/use-locale';
import RatingStarIcon from './RatingStarIcon';

/**
 * RatingWidget component
 * Displays a rating out of 5 stars and the total number of reviews
 * See also [RatingStarIcon]
 */
export default function RatingWidget({
  numberOfStars = 5,
  rating,
  showText = true,
  size = '1.5rem',
  totalReviews,
}: RatingWidgetProps) {
  const locale = useLocale();
  const totalReviewsLabel = Intl.NumberFormat(locale).format(totalReviews);
  return (
    <div className="flex w-max gap-x-2">
      <div className="flex gap-x-0.5">
        {Array.from({length: numberOfStars}, (_, index) => (
          <RatingStarIcon fillValue={rating - index} key={index} size={size} />
        ))}
      </div>
      {showText && (
        <span className="text-xl font-medium text-dark-blue-gray">
          {totalReviewsLabel}
        </span>
      )}
    </div>
  );
}

export type RatingWidgetProps = {
  numberOfStars?: number;
  rating: number;
  showText?: boolean;
  size?: string;
  totalReviews: number;
};
